<div class="register form-frame wide">
  <app-logo></app-logo>

  <div class="form-frame__body">

    <app-progress
      [percent]="'80'">
    </app-progress>

    <div class="form-frame__body-head">
      <app-back-button></app-back-button>
      <h2 class="headline">{{'PRODUCTS_PAGE.TITLE' | translate}}</h2>
    </div>

    <p
      class="form-frame__body-description">
      {{'PRODUCTS_PAGE.DESCRIPTION' | translate}}
    </p>

    <div class="form-frame__body-inputs">
      <label
        *ngFor="let item of productList"
        class="checkbox">
        <input
          (change)="selectProduct(item.code)"
          [checked]="selectedProductList.includes(item.code)"
          type="checkbox"
          class="checkbox__input checkboxItem">
        <span class="checkbox__icon"></span>
        <span
          class="checkbox__name">
          {{item.name | translate}}
        </span>
      </label>
    </div>

    <button
      (click)="sendForm()"
      [disabled]="selectedProductList.length === 0"
      class="btn btn-accent">
      {{'PRODUCTS_PAGE.CONTINUE' | translate}}
    </button>

  </div>

  <app-lang-select></app-lang-select>
</div>

